import { render, staticRenderFns } from "./choose_partner_city.vue?vue&type=template&id=af222e8e&scoped=true&"
import script from "./choose_partner_city.vue?vue&type=script&lang=js&"
export * from "./choose_partner_city.vue?vue&type=script&lang=js&"
import style0 from "./choose_partner_city.vue?vue&type=style&index=0&id=af222e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af222e8e",
  null
  
)

export default component.exports